import { all } from 'redux-saga/effects';
import { runSearchProjectsDetector } from 'app-entities/projects/search-projects.saga';

export function* rootSaga() {
  yield all([runSearchProjectsDetector()]);
}